import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import BaseCheckboxTheme from '../../form/BaseCheckboxTheme.jsx';

const RolePermissionItem = ({ permission, organizationId, maxPermission }) => {
    const formContext = useFormContext();
    if (!formContext) return null;

    const { watch, setValue, control } = formContext;

    const readChecked = watch(`permissions.${organizationId}.${permission.value}.read`);
    const createChecked = watch(`permissions.${organizationId}.${permission.value}.create`);
    const updateChecked = watch(`permissions.${organizationId}.${permission.value}.update`);
    const deleteChecked = watch(`permissions.${organizationId}.${permission.value}.delete`);

    useEffect(() => {
        if (readChecked) {
            setValue(`permissions.${organizationId}.${permission.value}.create`, createChecked);
            setValue(`permissions.${organizationId}.${permission.value}.update`, updateChecked);
            setValue(`permissions.${organizationId}.${permission.value}.delete`, deleteChecked);
        } else {
            setValue(`permissions.${organizationId}.${permission.value}.create`, false);
            setValue(`permissions.${organizationId}.${permission.value}.update`, false);
            setValue(`permissions.${organizationId}.${permission.value}.delete`, false);
        }
    }, [readChecked, setValue, organizationId, permission.value, createChecked, updateChecked, deleteChecked]);

    return (
        <div className='flex gap-4 border-t border-theme1-disabled pt-2 pb-2'>
            <BaseCheckboxTheme
                name={`permissions.${organizationId}.${permission.value}.read`}
                control={control}
                label='Read'
                disabled={!maxPermission.read}
                inputClassName={`${!maxPermission.read ? 'border-theme1-disabled' : ''}`}
                onChange={(e) => setValue(`permissions.${organizationId}.${permission.value}.read`, e.target.checked)}
                innerWrapperClassName='flex-col-reverse gap-1'
                labelClassName={`text-[11px] font-bold text-theme1-primary2 ${!maxPermission.read ? 'text-theme1-disabled' : ''}`}
            />
            <BaseCheckboxTheme
                name={`permissions.${organizationId}.${permission.value}.create`}
                control={control}
                label='Create'
                disabled={!maxPermission.create || !readChecked}
                inputClassName={`${!maxPermission.create || !readChecked ? 'border-theme1-disabled' : ''}`}
                labelClassName={`text-[11px] font-bold text-theme1-primary2 ${!maxPermission.create || !readChecked ? 'text-theme1-disabled' : ''}`}
                innerWrapperClassName='flex-col-reverse gap-1'
            />
            <BaseCheckboxTheme
                name={`permissions.${organizationId}.${permission.value}.update`}
                control={control}
                label='Update'
                disabled={!maxPermission.update || !readChecked}
                inputClassName={`${!maxPermission.update || !readChecked ? 'border-theme1-disabled' : ''}`}
                labelClassName={`text-[11px] font-bold text-theme1-primary2 ${!maxPermission.update || !readChecked ? 'text-theme1-disabled' : ''}`}
                innerWrapperClassName='flex-col-reverse gap-1'
            />
            <BaseCheckboxTheme
                name={`permissions.${organizationId}.${permission.value}.delete`}
                control={control}
                label='Delete'
                disabled={!maxPermission.delete || !readChecked}
                inputClassName={`${!maxPermission.delete || !readChecked ? 'border-theme1-disabled' : ''}`}
                labelClassName={`text-[11px] font-bold text-theme1-primary2 ${!maxPermission.delete || !readChecked ? 'text-theme1-disabled' : ''}`}
                innerWrapperClassName='flex-col-reverse gap-1'
            />
        </div>
    );
};

const MemoizedRolePermissionItem = React.memo(RolePermissionItem);
MemoizedRolePermissionItem.displayName = 'RolePermissionItem';

export default MemoizedRolePermissionItem;
